import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

import { ADMIN_ROLE } from './roles';
import { SessionService } from './session.service';

@Injectable({ providedIn: 'root' })
export class AdminRoleGuard implements CanActivate {
  constructor(private session: SessionService, private router: Router) {}

  canActivate(): boolean | UrlTree {
    if (this.session.checkRole() === ADMIN_ROLE) {
      return true;
    }

    return this.router.parseUrl('/dashboard');
  }
}
